import React from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import NewComplaint from "../components/complaints/NewComplaint";

const CreateComplaintPage = () => {
  return (
    <>
      <PageLayout>
        <SearchHeader />
        <div className="inner-main-content">
          <NewComplaint />
        </div>
      </PageLayout>
    </>
  );
};

export default CreateComplaintPage;
